import { fetchData } from 'Utils/fetch-data';
import type { FetchResponseI, BaseFilterI } from '../../types/index';

export class BaseApi<T, F = BaseFilterI> {
  endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  async create(data: T): Promise<FetchResponseI<T>> {
    return await fetchData<T>(this.endpoint, {
      method: 'POST',
      data,
    });
  }

  async readUnique(id: string): Promise<FetchResponseI<T>> {
    return await fetchData<T>(`${this.endpoint}/${id}`, {
      method: 'GET',
    });
  }

  async readAll(filters?: F): Promise<FetchResponseI<T[]>> {
    return await fetchData<Array<T>>(this.endpoint, {
      method: 'GET',
      params: filters,
    });
  }

  async update(id: string, data: T): Promise<FetchResponseI<T>> {
    return await fetchData<T>(`${this.endpoint}/${id}`, {
      method: 'PUT',
      data,
    });
  }

  async destroy(id: string): Promise<FetchResponseI<boolean>> {
    return await fetchData<boolean>(`${this.endpoint}/${id}`, {
      method: 'DELETE',
    });
  }
}
